import { videoAnalytics } from '#/config/constants';

export const isRequiredOperationalEvent = event =>
  event === videoAnalytics.events.VIDEO_HEARTBEAT;

export const canSendAnalyticsEvent = (event, analyticsConsent) =>
  analyticsConsent || isRequiredOperationalEvent(event);

export const getAnalyticsEventParams = (
  event,
  payload,
  defaultParams,
  analyticsConsent,
) => {
  if (!canSendAnalyticsEvent(event, analyticsConsent)) {
    return null;
  }

  if (analyticsConsent) {
    return {
      ...payload,
      ...defaultParams,
    };
  }

  // Required playback measurement remains cookieless and excludes the
  // installation ID, user agent, user ID, and optional user properties.
  return {
    ...payload,
    device_type: defaultParams.device_type,
  };
};
